import React, { useEffect, useState } from "react";
import Parse from "parse";
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { Box } from "@mui/material";
import { setSelectedClient } from "../features/cart/cartSlice";
import { useDispatch, useSelector } from "react-redux";

// Own cache key: 'clients' is also written by the Clients page with raw Parse JSON.
const CLIENT_OPTIONS_KEY = 'clientOptions';

/**
 * Autocomplete needs a string for every option and for the current value. Clients arrive
 * here in two shapes: the option built below, and the raw ClientDetails JSON stored on a
 * quotation (no label, objectId instead of id). Build the label from the fields when the
 * shape doesn't carry one.
 */
const clientLabel = (client) => {
  if (!client) return '';
  if (typeof client === 'string') return client;
  if (client.label) return client.label;
  const { companyName, firstName, lastName, email, phoneNumber } = client;
  return `${companyName ?? ''} - ${firstName ?? ''} ${lastName ?? ''} - ${email ?? ''} - ${phoneNumber ?? ''}`;
};

const clientId = (client) => client?.id ?? client?.objectId;

const SelectClients = (props) => {
  const [clientsData, setClientsData] = useState([]);
  const selectedClientFromStore = useSelector((state) => state.cart.selectedClient);
  const requestForClientsReload = props.requestForClientsReload;
  const setRequestForClientsReload = props.setRequestForClientsReload;
  const dispatch = useDispatch();
  const disabled = props.disabled
  const setFetchingClients = props.setFetchingClients
  const fetchingClients = props.fetchingClients

  useEffect(() => {
    localStorage.removeItem('clients'); // legacy cache, no longer read
    if (localStorage.getItem(CLIENT_OPTIONS_KEY)) {
      setClientsData(JSON.parse(localStorage.getItem(CLIENT_OPTIONS_KEY)));
    } else {
      getQuotationsData();
    };
  }, []);

  useEffect(() => {
    if (requestForClientsReload) {
      getQuotationsData();
    }
  }, [requestForClientsReload]);

  const getQuotationsData = async () => {
    try {
      setFetchingClients(true);
      localStorage.removeItem(CLIENT_OPTIONS_KEY);
      const clientsObj = Parse.Object.extend("ClientDetails");
      const query = new Parse.Query(clientsObj).limit(100000);
      const res = await query.find();
      const clients = []
      res.forEach((client) => {
          clients.push({label: clientLabel(client.toJSON()), parseObject: client, email: client.get('email'), id: client.id})
      });
      localStorage.setItem(CLIENT_OPTIONS_KEY, JSON.stringify(clients));
      setClientsData(clients);
      setRequestForClientsReload(false);
      setTimeout(() => {
        setFetchingClients(false);
      }, 10000);
    } catch (error) {
      console.log('errpr: ', error);
    }
  };

  return (
    <Autocomplete
      disablePortal
      id="combo-box-demo"
      sx={{ width: 300 }}
      options={clientsData}
      getOptionLabel={clientLabel}
      isOptionEqualToValue={(option, value) => {
        const optionId = clientId(option);
        return optionId !== undefined && optionId === clientId(value);
      }}
      renderOption={(props, option) => (
        <Box component="li" {...props} key={clientId(option)}>
          {clientLabel(option)}
        </Box>
      )}
      disabled={disabled || fetchingClients}
      value={selectedClientFromStore}
      onChange={(event, newValue) => {dispatch(setSelectedClient(newValue)); }}
      renderInput={(params) => <TextField className="primary-color" {...params} label="email" />}
    />
  );
};

export default SelectClients;
